import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-modal-content-confirm-abandon',
  templateUrl: './modal-content-confirm-abandon.component.html',
  standalone: false,
})
export class ModalContentConfirmAbandonComponent {
  @Output() public readonly closed = new EventEmitter<boolean>();

  close(isConfirming: boolean) {
    this.closed.emit(isConfirming);
  }
}
